import { render, staticRenderFns } from "./UserHelp.vue?vue&type=template&id=e0ca07a4&"
import script from "./UserHelp.vue?vue&type=script&lang=ts&"
export * from "./UserHelp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports